import { environment } from '../../environments/environment';

export const APP_TITLE = environment.appTitle;